import { ScopeButton } from '@monorepo/shared-lib';
import { ReactComponent as IconFuzzyMapping } from 'assets/images/icons/iconFuzzyMapping.svg';
import { Row, Space, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnModalOff } from 'store/app/actions';
import { getInterpretationRuleFieldLabel } from './interpretation-rule-field-options';
import type { RuleEditSuggestion } from './suggest-rule-from-edit';
import type { InterpretationRuleField } from './types';

const { Text } = Typography;

interface SuggestInterpretationRuleModalProps {
  suggestion: RuleEditSuggestion;
  onCreateRule: () => void;
}

export const SuggestInterpretationRuleModal: React.FC<
  SuggestInterpretationRuleModalProps
> = ({ suggestion, onCreateRule }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const actionField = getInterpretationRuleFieldLabel(
    t,
    suggestion.actionField as InterpretationRuleField
  );
  const conditionField = getInterpretationRuleFieldLabel(
    t,
    suggestion.conditionField as InterpretationRuleField
  );

  const title = t('organisation.extraction-rules.suggest-rule-title');
  const intro = t('organisation.extraction-rules.suggest-rule-message-intro', {
    actionField,
    conditionField,
    conditionValue: suggestion.conditionValue,
  });
  const prompt = t('organisation.extraction-rules.suggest-rule-message-prompt');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 24,
        width: '100%',
        maxWidth: 650,
        margin: '0 auto',
      }}
    >
      <span
        aria-hidden
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 72,
          height: 72,
          borderRadius: 16,
          background: '#fff5e2',
          border: '1px solid rgba(201, 138, 0, 0.25)',
          color: '#7a5a00',
        }}
      >
        <IconFuzzyMapping style={{ width: 40, height: 40 }} />
      </span>
      <span style={{ fontWeight: 600, fontSize: 16, textAlign: 'center' }}>
        {title}
      </span>
      <Row justify="center">
        <Text style={{ textAlign: 'center', color: 'var(--color-text-muted, #5a6a6a)', fontSize: 13 }}>
          {intro}
        </Text>
      </Row>
      <Row justify="center">
        <Text style={{ textAlign: 'center', color: 'var(--color-text-muted, #5a6a6a)', fontSize: 13 }}>
          {prompt}
        </Text>
      </Row>
      <Row justify="center">
        <Space>
          <ScopeButton
            type="default"
            width="100px"
            height="40px"
            onClick={() => dispatch(turnModalOff())}
          >
            {t('common.pwa-install-dismiss')}
          </ScopeButton>
          <ScopeButton
            type="primary"
            width="fit-content"
            height="40px"
            onClick={() => {
              dispatch(turnModalOff());
              // Open create modal after close so TURN_MODAL_OFF does not clear it.
              window.setTimeout(() => onCreateRule(), 0);
            }}
          >
            {t('organisation.extraction-rules.suggest-rule-create')}
          </ScopeButton>
        </Space>
      </Row>
    </div>
  );
};
